import { Dialog, Grid, Typography } from '@mui/material';
import { ModalHeader } from 'pages/variants/common/modal-header';
import ActionButton from 'components/buttons/index';
import { styles } from './styles';

interface INoVariantsModal {
  open: boolean;
  onClose: () => void;
}

export const NoVariantsModal = ({ open, onClose }: INoVariantsModal) => {
  return (
    <Dialog open={open} sx={styles.dialog} onClose={onClose}>
      <ModalHeader heading="No Available Variants" />
      <Grid sx={styles.content}>
        <Typography sx={styles.typo}>This option has no available variants left.</Typography>

        <Grid sx={styles.btn}>
          <ActionButton label="Cancel" variant="secondary" onClick={onClose} />
        </Grid>
      </Grid>
    </Dialog>
  );
};
